// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"numbers-circle-2"},"children":[{"tag":"circle","attrs":{"id":"fill1","cx":12,"cy":12,"r":10,"fill":"props.fillColor1"}},{"tag":"circle","attrs":{"id":"stroke1","cx":12,"cy":12,"r":10,"stroke":"props.strokeColor1","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M15 17.5H9V16.0157C9 15.7949 9.10177 15.5858 9.27706 15.4466L13.8737 11.7948C14.5863 11.2287 15 10.3788 15 9.48109V9.43333C15 7.8133 13.6569 6.5 12 6.5C10.3431 6.5 9 7.8133 9 9.43333","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const NumbersCircle2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'numbers-circle-2',
    ref,
    icon: element,
  },
));

NumbersCircle2Icon.displayName = 'NumbersCircle2Icon';

export default NumbersCircle2Icon;
